module.exports = __webpack_public_path__ + "img/welcomes-preview-vip.51dba78e.png";